import { render, staticRenderFns } from "./SliceImagesGrid.vue?vue&type=template&id=ec53d15e&lang=pug&"
import script from "./SliceImagesGrid.vue?vue&type=script&lang=js&"
export * from "./SliceImagesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports